import * as React from 'react';

export const AnnouncementBannerHeightContext = React.createContext(null);

export const useAnnouncementBannerHeight = () => {
  const result = React.useContext(AnnouncementBannerHeightContext);

  return result;
}
